import Vue from 'vue'
import Vuex from 'vuex'
import { mutations, actions } from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js